export const REP_EDITABLE_FIELDS = [
  "name", "phone", "territory", "target", "monthly_target", "area_from", "area_to",
  "age", "sex", "address", "salary",
];
export const REP_PRIVATE_FIELDS = ["age", "sex", "address", "salary"];

export function repMonthlyTarget(rep = {}) {
  return rep.monthly_target !== undefined && rep.monthly_target !== null
    ? rep.monthly_target : (rep.target !== undefined && rep.target !== null ? rep.target : 0);
}

export function repPeriodTargets(rep = {}) {
  const monthly = Number(repMonthlyTarget(rep)) || 0;
  return { monthly, quarterly: monthly * 3, halfYearly: monthly * 6, yearly: monthly * 12 };
}

export function buildRepPayload(form, canManageUsers) {
  const payload = {};
  ["name", "phone", "territory", "area_from", "area_to"].forEach((key) => {
    if (form[key] !== undefined) payload[key] = String(form[key] || "").trim();
  });
  const monthly = form.monthly_target !== undefined ? form.monthly_target : form.target;
  if (monthly !== undefined) {
    if (monthly === "") {
      payload.monthly_target = 0;
    } else {
      const value = Number(monthly);
      if (!Number.isFinite(value) || value < 0) throw new Error("Monthly target must be a finite, non-negative amount.");
      payload.monthly_target = value;
    }
  }
  if (canManageUsers) {
    ["age", "sex", "address"].forEach((key) => {
      if (form[key] !== undefined) payload[key] = key === "age" ? (form[key] === "" ? null : Number(form[key])) : form[key];
    });
    if (form.salary !== undefined) {
      if (form.salary === "") payload.salary = 0;
      else {
        const value = Number(form.salary);
        if (!Number.isFinite(value) || value < 0) throw new Error("Monthly salary must be a finite, non-negative amount.");
        payload.salary = value;
      }
    }
  }
  return payload;
}

export function validateRepForm(form, canManageUsers) {
  if (!String(form.name || "").trim()) return "Name is required.";
  try { buildRepPayload(form, canManageUsers); } catch (error) { return error.message; }
  if (canManageUsers && form.age !== "" && form.age !== null && form.age !== undefined) {
    const age = Number(form.age);
    if (!Number.isInteger(age) || age < 16 || age > 100) return "Age must be a whole number between 16 and 100.";
  }
  return "";
}